module.exports = __webpack_public_path__ + "static/media/copy-link.642c323f.svg";